declare global {
  interface Window {
    dataLayer: any[];
  }
}

// NOTE: The GTM container is now loaded by the standard snippet in the static
// <head> of client/index.html (so Google's detectors find it immediately). We
// intentionally do NOT inject gtm.js from here anymore — doing so would load the
// container twice. This module only pushes SPA page_view events, and only on
// public routes (gated by the caller in PublicPageTracker.tsx). Keeping tracking
// off the authenticated app is enforced here (no pushes) AND in the GTM dashboard
// via trigger hostname/path conditions.

export const trackGTMPageView = (url: string) => {
  if (typeof window === "undefined" || !window.dataLayer) return;
  if (!import.meta.env.VITE_GTM_ID) return;

  window.dataLayer.push({
    event: "page_view",
    page_path: url,
  });
};
